import { storage } from '../../firebase'; // Corrected path to firebase.ts (after rename)
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

class FirebaseUploadAdapter {
    private loader: any; // CKEditor 5 FileLoader instance
    private storagePath: string;

    constructor(loader: any, storagePath: string = 'ckeditor_uploads') {
        this.loader = loader;
        this.storagePath = storagePath;
    }

    upload(): Promise<{ default: string }> {
        return this.loader.file
            .then((file: File) => new Promise((resolve, reject) => {
                if (!file) {
                    return reject('File not found.');
                }
                const fileName = `${this.storagePath}/${uuidv4()}-${file.name}`;
                const storageRef = ref(storage, fileName);

                uploadBytes(storageRef, file)
                    .then(snapshot => {
                        getDownloadURL(snapshot.ref)
                            .then(downloadURL => {
                                resolve({
                                    default: downloadURL
                                });
                            })
                            .catch(error => {
                                console.error("Firebase Storage: Error getting download URL", error);
                                reject(`Failed to get download URL: ${error.message}`);
                            });
                    })
                    .catch(error => {
                        console.error("Firebase Storage: Error uploading file", error);
                        reject(`Failed to upload file: ${error.message}`);
                    });
            }));
    }

    abort(): void {
        // Firebase Storage uploads cannot be easily aborted client-side with uploadBytes.
        // For more complex scenarios (like resumable uploads with uploadString/put), 
        // you might get an UploadTask to call .cancel() on.
        // For simple uploads, this is often a no-op.
        console.warn('FirebaseUploadAdapter: Upload aborted (no-op for simple uploads).');
    }
}

// Plugin function to integrate with CKEditor
export function FirebaseUploadAdapterPlugin(editor: any): void {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
        // Configure the storage path for uploads.
        // You can make this path more specific if needed, e.g., per user or per feature.
        // For now, using 'ckeditor_uploads/images' to keep images organized.
        return new FirebaseUploadAdapter(loader, 'ckeditor_uploads/images');
    };
} 